export type Locale = "de" | "en";

export type Translation = Record<Locale, { [key: string]: string }>;

export const render = (
  text: string,
  variables: { [key: string]: string | number | null | undefined },
): string => {
  return Object.entries(variables).reduce((v, [key, value]) => {
    return value ? v.replaceAll(`{${key}}`, value.toString()) : v;
  }, text);
};
